import { Component, OnInit } from '@angular/core';
import { RouterPath } from '../../shared/models';
import { DpfService } from '../../core/services/dpf.service';
import { LocaleService } from '../../core/services/locale.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    protected readonly RouterPath = RouterPath;
    footerSectionOpen = {
        about: true,
        requests: true,
        policies: true,
        contributions: true,
    };
    email = '';
    subscribeStatus = false;
    currentLocale = 'en';

    constructor(
        private dpfService: DpfService,
        private localeService: LocaleService
    ) {}

    ngOnInit() {
        // Initialize from translation service (which handles URL and storage)
        this.currentLocale = this.localeService.getCurrentLocale();

        // Subscribe to language changes
        this.localeService.getCurrentLocale$().subscribe(lang => {
            this.currentLocale = lang;
        });
    }

    toggleFooterSection(key: any) {
        this.footerSectionOpen[key] = !this.footerSectionOpen[key];
    }

    subscribe() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (this.email && emailRegex.test(this.email)) {
            this.dpfService.subscribe({email: this.email}).subscribe(val => {
                if (val?.status) {
                    this.subscribeStatus = true;
                }
            });
        }
    }

    getBlogUrl(): string {
        return `https://blog.datacore.vn/${this.currentLocale}/`;
    }

    getNewsUrl(): string {
        switch (this.currentLocale) {
            case 'vi':
                return 'https://blog.datacore.vn/vi/news-2';
            case 'en':
                return 'https://blog.datacore.vn/en/news';
            default:
                return `https://blog.datacore.vn/${this.currentLocale}/news`;
        }
    }

    getAILeaderboardUrl(): string {
        switch (this.currentLocale) {
            case 'vi':
                return 'https://airank.datacore.vn/?lang=vi';
            case 'en':
                return 'https://airank.datacore.vn/?lang=en';
            default:
                return `https://airank.datacore.vn/?lang=${this.currentLocale}`;
        }
    }
}
